import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, ArrowLeft, ShieldAlert } from "lucide-react";

export default function NotFound() {
  return (
    <div data-testid="notfound-page" className="relative flex min-h-screen items-center justify-center overflow-hidden px-6">
      <div className="tech-grid absolute inset-0 opacity-40" />
      <div className="glow-blue pointer-events-none absolute left-1/2 top-1/2 h-[500px] w-[500px] -translate-x-1/2 -translate-y-1/2" />
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="relative text-center">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-[#2563EB]/15 text-[#60A5FA]"><ShieldAlert className="h-8 w-8" /></span>
        <h1 className="mt-8 font-display text-7xl font-extrabold tracking-tight text-white lg:text-9xl">404</h1>
        <p className="mt-4 font-display text-2xl font-bold text-white">Page not found</p>
        <p className="mx-auto mt-3 max-w-md text-slate-400">The page you're looking for has moved or no longer exists. Let's get you back to safety.</p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
          <Link to="/" data-testid="notfound-home-button" className="inline-flex items-center gap-2 rounded-full bg-[#2563EB] px-6 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-[#3b82f6]"><Home className="h-4 w-4" /> Back to Home</Link>
          <Link to="/contact" className="inline-flex items-center gap-2 rounded-full border border-slate-700 px-6 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-white/5"><ArrowLeft className="h-4 w-4" /> Contact Us</Link>
        </div>
      </motion.div>
    </div>
  );
}
